module.exports = __webpack_public_path__ + "static/media/arrow-circle-empty-light-left.d4b93957.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-empty-light-left.svg
// module id = 638
// module chunks = 0